<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card class="elevation-12">
          <v-toolbar color="light-blue " dark>
            <v-toolbar-title class=" text-xs-center">Contact Us</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div id="subheader">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field class="input-class-new" v-model="name" placeholder="Your name" type="text" prepend-icon="account_box" :rules="[rules.required, rules.nameLimit]" validate-on-blur></v-text-field>
              <v-text-field class="input-class-new" v-model="email" placeholder="Your email address" type="text" prepend-icon="email" :rules="[rules.required, rules.email]" validate-on-blur></v-text-field>
              <v-textarea class="input-class-new" v-model="message" placeholder="Your message" type="text" counter prepend-icon="textsms" :rules="[rules.required]" validate-on-blur></v-textarea>
              <v-btn @click="sendMessage" color="info">Send</v-btn>
              <br><br>
            </v-form>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {EventBus} from '@/event-bus.js'
export default {
  data: () => ({
    name: null,
    email: null,
    message: null,
    valid: true,
    rules: {
      required: value => !!value || 'Required',
      email: value => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(value).toLowerCase()) || 'Please enter a valid email address',
      nameLimit: value => String(value).length < 50 || 'Name must be at most 50 characters'
    }
  }),
  methods: {
    sendMessage() {
      if(!this.$refs.form.validate()) {
        EventBus.$emit('send-notification', {text: 'Invalid fields'});
        return;
      }
      this.$http.post(this.$store.state.serverHttpUrl+'/contactus', {
        name: this.name,
        email: this.email,
        message: this.message,
      }).then(function(response) {
        EventBus.$emit('send-notification', {text: 'Message successfully sent', color: 'success'});
        this.$refs.form.reset();
      }, function (err) {
        EventBus.$emit('send-notification', {text: 'Error sending message (' + err.body + ')'});
      });
    }
  }
}
</script>

<style scoped>
  #subheader {
    margin: 20px;
    font-size: 20px;
    line-height: 1.5;
  }
  .input-class-new {
    width: 80%;
    position: relative;
    left: 10%;
  }
</style>




// WEBPACK FOOTER //
// src/components/ContactUs/ContactUs.vue